/**
 * Games' public/ assets, resolved through the static manifest.
 *
 * Only the pre-computed maze CONFIGS move to the CDN (2.89 MB of the
 * maze-templates directory's 2.90 MB): the browser fetches them, while the .svg
 * silhouettes beside them are read from disk by enqueueMazeGeneration and must
 * stay in the artifact. See docs/ops/static-cdn.md.
 *
 * NEXT_PUBLIC_STATIC_BASE_URL unset (dev) → the path is returned untouched.
 */
import { createStaticUrl } from '@owlcat/app-shell/static-assets';
import manifest from '../static-manifest.json';

export const staticUrl = createStaticUrl(manifest as Record<string, string>);
